function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire420a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire420a"] = parcelRequire;
}
parcelRequire.register("20Q2C", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $1773f32e6e416ffb$export$6503ec6e8aabbaf; }, function (v) { return $1773f32e6e416ffb$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $1773f32e6e416ffb$export$f7ad0328861e2f03; }, function (v) { return $1773f32e6e416ffb$export$f7ad0328861e2f03 = v; });
var $1773f32e6e416ffb$export$6503ec6e8aabbaf;
var $1773f32e6e416ffb$export$f7ad0328861e2f03;
"use strict";
var $1773f32e6e416ffb$var$mapping = {};
function $1773f32e6e416ffb$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$1773f32e6e416ffb$var$mapping[keys[i]] = pairs[keys[i]];
}
function $1773f32e6e416ffb$var$resolve(id) {
    var resolved = $1773f32e6e416ffb$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$1773f32e6e416ffb$export$6503ec6e8aabbaf = $1773f32e6e416ffb$var$register;
$1773f32e6e416ffb$export$f7ad0328861e2f03 = $1773f32e6e416ffb$var$resolve;

});

var $ff8f16db43616eae$exports = {};

(parcelRequire("20Q2C")).register(JSON.parse('{"8GKQY":"index.2ab4ca8a.js","d7O5J":"pp-logo.c173f6dd.svg","5jQuC":"pp-logo-light.9722f388.svg","bovx8":"index.538763d5.css"}'));


//# sourceMappingURL=index.ac7241ba.js.map
